import React from 'react';
import { Link, useParams } from 'react-router-dom';
import StatusWidget from '../../DataTables/DataTableComponents/StatusWidget';

var pdf = require('../../../../assets/images/document.png');

export default function PropertyDocumentsCard(props) {
	return (
		<div className="PropertyDocumentsCard bg-white w-full min-w-96 mt-4 p-5 rounded-md shadow border text-gray-800">
			<div className="grid lg:grid-cols-12 lg:gap-5">
				<div className="col-span-12 lg:col-span-2">
					<h2 className="text-lg lg:text-xl font-semibold mb-2">Documents</h2>
				</div>
				<div className="col-span-12 lg:col-span-10">
					<div className="border p-4 bg-gray-50 shadow-sm rounded-md mb-5">
						<Link to="poa">
							<span className="float-right hover:underline">Edit</span>
						</Link>
						<h3 className="font-semibold">Hawaii Power of Attorney</h3>
						<div>
							<img
								src={pdf}
								className="m-2 inline"
								style={{ height: '50px' }}
							/>
							<StatusWidget status="Pending" />
						</div>
					</div>
					<div className="border p-4 bg-gray-50 shadow-sm rounded-md mb-5">
						<Link to="poa">
							<span className="float-right hover:underline">Edit</span>
						</Link>
						<h3 className="font-semibold">
							BB-1 Hawaii State Business License Application
						</h3>
						<div>
							<img
								src={pdf}
								className="m-2 inline"
								style={{ height: '50px' }}
							/>
							<StatusWidget status="Pending" />
						</div>
					</div>
					<div className="border p-4 bg-gray-50 shadow-sm rounded-md">
						<span className="float-right hover:underline">View</span>
						<h3 className="font-semibold">Maui Local Business License</h3>
						<div>
							<img
								src={pdf}
								className="m-2 inline"
								style={{ height: '50px' }}
							/>
							<StatusWidget status="Active" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
